import { render } from "./LoginInbox.vue?vue&type=template&id=433d68e6"
import script from "./LoginInbox.vue?vue&type=script&lang=js"
export * from "./LoginInbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__